import { type FC, useEffect, useState } from 'react';

import type { Props } from '@/components/EndTreatmentGroupModal/types';
import { useEndTreatmentGroup } from '@/hooks/useTreatmentGroups';
import { InputGroup, Modal, MondayPicker } from '@/ui';
import { getNextMonday, parseIsoDate } from '@/utils/dates';

const EndTreatmentGroupModal: FC<Props> = ({ group, onClose }) => {
  const endTreatmentGroup = useEndTreatmentGroup();
  const [endDate, setEndDate] = useState(getNextMonday());

  // Reset to the next Monday each time a new group is opened for ending.
  useEffect(() => {
    if (group) setEndDate(getNextMonday());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [group?.id]);

  const confirmEnd = () => {
    if (!group) return;
    endTreatmentGroup.mutate({ id: group.id, endDate }, { onSuccess: onClose });
  };

  return (
    <Modal
      open={group !== null}
      onClose={onClose}
      title="Set the end date"
      description={`Choose the Monday "${group?.name}" and its sessions will end.`}
      overflowVisible
      secondaryAction={{ label: 'Cancel', onClick: onClose }}
      primaryAction={{
        label: 'End group',
        onClick: confirmEnd,
        isLoading: endTreatmentGroup.isPending,
        disabled: endTreatmentGroup.isPending
      }}>
      <InputGroup>
        <MondayPicker
          label="End date"
          name="endDate"
          value={endDate}
          onChange={(value) => setEndDate(value ?? getNextMonday())}
          minDate={parseIsoDate(getNextMonday())}
        />
      </InputGroup>
    </Modal>
  );
};

export default EndTreatmentGroupModal;
